import React from 'react';
import { Box, FormControl, Grid, InputLabel, MenuItem, Select } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import TextField from '@mui/material/TextField';
import dayjs from 'dayjs';
import { DD_MM_YYYY } from '../../pages/Tasks/TaskConstants';

const STATUS_LABELS = {
  '': 'All',
  PENDING: 'Pending',
  APPROVED: 'Approved',
  REJECTED: 'Rejected',
};

const RemoteOfficeHoursTaskFilters = ({ filters, setFilters, projects }) => {
  const selectedProject = projects.find(
    (project) =>
      String(project.projectId || project.id) === String(filters.projectId),
  );

  return (
    <Box sx={{ mb: 3 }}>
      <Grid container spacing={2}>
        <Grid item xs={12} md={3}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              label="Start Date"
              inputFormat={DD_MM_YYYY}
              value={dayjs(filters.startDate)}
              maxDate={dayjs(filters.endDate)}
              onChange={(value) =>
                setFilters((prev) => ({
                  ...prev,
                  startDate: value.format('YYYY-MM-DD'),
                }))
              }
              renderInput={(params) => (
                <TextField {...params} fullWidth size="small" />
              )}
            />
          </LocalizationProvider>
        </Grid>
        <Grid item xs={12} md={3}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              label="End Date"
              inputFormat={DD_MM_YYYY}
              value={dayjs(filters.endDate)}
              minDate={dayjs(filters.startDate)}
              maxDate={dayjs()}
              onChange={(value) =>
                setFilters((prev) => ({
                  ...prev,
                  endDate: value.format('YYYY-MM-DD'),
                }))
              }
              renderInput={(params) => (
                <TextField {...params} fullWidth size="small" />
              )}
            />
          </LocalizationProvider>
        </Grid>
        <Grid item xs={12} md={3}>
          <FormControl fullWidth size="small">
            <InputLabel id="remote-office-hours-project-label" shrink>
              Project
            </InputLabel>
            <Select
              labelId="remote-office-hours-project-label"
              id="remote-office-hours-project"
              displayEmpty
              value={filters.projectId}
              label="Project"
              renderValue={() => selectedProject?.projectName || 'All Projects'}
              onChange={(e) =>
                setFilters((prev) => ({ ...prev, projectId: e.target.value }))
              }
            >
              <MenuItem value="">All Projects</MenuItem>
              {projects.map((project) => (
                <MenuItem
                  key={project.projectId || project.id}
                  value={project.projectId || project.id}
                >
                  {project.projectName}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12} md={3}>
          <FormControl fullWidth size="small">
            <InputLabel id="remote-office-hours-status-label" shrink>
              Status
            </InputLabel>
            <Select
              labelId="remote-office-hours-status-label"
              id="remote-office-hours-status"
              displayEmpty
              value={filters.status}
              label="Status"
              renderValue={(selected) => STATUS_LABELS[selected] || 'All'}
              onChange={(e) =>
                setFilters((prev) => ({ ...prev, status: e.target.value }))
              }
            >
              <MenuItem value="">All</MenuItem>
              <MenuItem value="PENDING">Pending</MenuItem>
              <MenuItem value="APPROVED">Approved</MenuItem>
              <MenuItem value="REJECTED">Rejected</MenuItem>
            </Select>
          </FormControl>
        </Grid>
      </Grid>
    </Box>
  );
};

export default RemoteOfficeHoursTaskFilters;
